function isGHMC() {
  return false;
}
export default isGHMC;

export const formatDate = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${day}/${month}/${year}`;
};

export const formattedDate = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${day}-${month}-${year}`;
};

export const formattedDateTypeTwo = (dateString) => {
  const [year, month, day] = dateString?.split('-');
  return `${day}-${month}-${year}`;
};

export const formattedDateForBE = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${year}-${month}-${day}`;
};

export const getFirstDateOfMonth = () => {
  const currentDate = new Date();
  currentDate.setDate(1); // Set to the 1st day of the current month

  // Format the date as YYYY-MM-DD
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding 1 since getMonth() is zero-indexed
  const day = String(currentDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export const formatDateTime = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const timeOnly = dateString?.split('T')[1];
  const [year, month, day] = dateOnly?.split('-');
  const [hour, minutes, secondsAndMilliSeconds] = timeOnly?.split(':');
  const [second, milliseconds] = secondsAndMilliSeconds?.split('.');
  return `${day}/${month}/${year} - ${hour}:${minutes}:${second}`;
};

export const formatDateTimeWithoutSec = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const timeOnly = dateString?.split('T')[1];
  const [year, month, day] = dateOnly?.split('-');
  const [hour, minutes] = timeOnly?.split(':');
  return `${day}/${month}/${year} - ${hour}:${minutes}`;
};

export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getCurrentISTDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
};

export const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export const getCurrentDateTime1 = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${day}-${month}-${year} ${hour}:${minute}`;
};

export const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

export const getStartOfCurrentDate1 = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDayMonthYearTime = (dateTimeStr) => {
  if (!dateTimeStr) {
    return 'N/A';
  }

  const date = new Date(dateTimeStr);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  // Extract date components
  const day = String(date.getDate()).padStart(2, '0'); // Add leading zero
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();

  // Extract time components
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format the date as DD-MM-YYYY HH:mm:ss
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const canWritePermission = (page) => {
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionName === page);
  return matchingPermission?.canWrite;
}
